import { render, staticRenderFns } from "./EBC2025.vue?vue&type=template&id=39b0f276&scoped=true&"
import script from "./EBC2025.vue?vue&type=script&lang=js&"
export * from "./EBC2025.vue?vue&type=script&lang=js&"
import style0 from "./EBC2025.vue?vue&type=style&index=0&id=39b0f276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0f276",
  null
  
)

export default component.exports